export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_BASE_URL,
  rbBaseUrl: process.env.VUE_APP_RB_URL,
  rbMiddleUrl: "/wbrb",
  userBaseUrl: "/mustang",
  actionLogAction: ["login", "host", "provider", "function", "page", "role", "pagerole", "user", "setting", "bot", "proxy", "league", "team", "match", "jobcontrol", "dangerzone", "rtfcommentary"],
  oddsCalculateFrom: {
    0: "N/A",
    1: "ALL",
    2: "SBO",
    3: "IBC"
  },
  addMatchException: [{
    checkLeague: true,
    checkTeam: false,
    league: "which team will advance to next round"
  },
  {
    checkLeague: true,
    checkTeam: false,
    league: "penalty shoot-out"
  },
  {
    checkLeague: true,
    checkTeam: true,
    league: "home team/away team",
    home: "home team",
    away: "away team"
  },
  {
    checkLeague: true,
    checkTeam: true,
    league: "corners",
    home: "home team no.of corners",
    away: "away team no.of corners"
  },
  {
    checkLeague: true,
    checkTeam: true,
    league: "booking",
    home: "home team total bookings",
    away: "away team total bookings"
  },
  {
    checkLeague: false,
    checkTeam: true,
    home: "(PEN)",
    away: "(PEN)"
  },
  {
    checkLeague: false,
    checkTeam: true,
    home: "(PEN - HDP)",
    away: "(PEN - HDP)"
  },
  {
    checkLeague: false,
    checkTeam: true,
    home: "(PEN - O/U)",
    away: "(PEN - O/U)"
  },
  {
    checkLeague: true,
    checkTeam: true,
    league: "corners",
    home: "home team",
    away: "away team"
  },
  {
    checkLeague: true,
    checkTeam: false,
    league: "FIFA WORLD CUP 2022 (IN QATAR) - FANTASY MATCH",
  },
  {
    checkLeague: true,
    checkTeam: false,
    league: "FIFA WORLD CUP 2022 (IN QATAR) - THROW IN",
  }],
  // leagueSpecialException: ["which team will advance to next round", "penalty shoot-out", "home team/away team", "corners", "esoccer", "booking"],
  // teamSpecialException: {
  //   "home team/away team": { home: "home team", away: "away team" },
  //   "corners": { home: "home team no.of corners", away: "away team no.of corners" },
  //   "booking": { home: "home team total bookings", away: "away team total bookings" }
  // },
  accessRoles: {
    status: "status",
    asidebar: "asidebar",
    login: "login",
    host: "host",
    provider: "provider",
    function: "function",
    page: "page",
    role: "role",
    user: "user",
    setting: "setting",
    omcache: "omcache",
    bot: "bot",
    proxy: "proxy",
    league: "league",
    mapleague: "mapleague",
    team: "team",
    mapteam: "mapteam",
    sbomatch: "sbomatch",
    ibcmatch: "ibcmatch",
    cmdmatch: "cmdmatch",
    linkedmatch: "linkedmatch",
    mapmatch: "mapmatch",
    jobcontrol: "jobcontrol",
    oddslog: "oddslog",
    automap: "automap",
    sbologin: "sbologin",
    ibclogin: "ibclogin",
    cmdlogin: "cmdlogin",
    sbobot: "sbobot",
    ibcbot: "ibcbot",
    cmdbot: "cmdbot",
    actionlog: "actionlog",
    unmapmatch: "unmapmatch",
    updatemapping: "updatemapping",
    dangerzone: "dangerzone",
    matchfeed: "matchfeed",
    rtfcommentary: "rtfcommentary",
    mapoutright: "mapoutright",
    remapmatch: "remapmatch",
    remapleague: "remapleague",
    remapteam: "remapteam",
    preaddmatch: "preaddmatch",
    preaddmatchcmd: "preaddmatchcmd",
    preaddmatchibet: "preaddmatchibet",
    jobcontrolsport: "jobcontrolsport",
    purgematch: "purgematch",
    sport: "sport",
    purgeleague: "purgeleague",
    purgesboleague: "purgesboleague",
    purgeteam: "purgeteam",
    purgesboteam: "purgesboteam",
    mapmatchothers: "mapmatchothers",
    leaguelog: "leaguelog",
    teamlog: "teamlog",
    mapleaguelog: "mapleaguelog",
    mapteamlog: "mapteamlog",
    purgeleaguelog: "purgeleaguelog",
    purgeteamlog: "purgeteamlog",
    purgesbomatchlog: "purgesbomatchlog",
    purgeibcmatchlog: "purgeibcmatchlog",
    providerlog: "providerlog",
    matchlog: "matchlog",
    auditlog: "auditlog",
    mapmatchlog: "mapmatchlog",
    preaddmatchlog: "preaddmatchlog",
    purgematchlog: "purgematchlog",
    hostlog: "hostlog",
    loginlog: "loginlog",
    proxylog: "proxylog",
    botlog: "botlog",
    jobcontrollog: "jobcontrollog",
    sportlog: "sportlog",
    matchclearrs: "matchclearrs",
    purgeibcteam: "purgeibcteam",
    rsrtcontrol: "rsrtcontrol",
    rbdata: "rbdata",
    efightapilog: "efightapilog",
    cmdsbomatch: "cmdsbomatch",
    cmdsbomapmatch: "cmdsbomapmatch",
    ibcibtmatch: "ibcibtmatch",
    ibcibtmapmatch: "ibcibtmapmatch",
    outrightdoublematch: "outrightdoublematch",
    ip: "ip",
    purgeibcleague: "purgeibcleague",
    purgesboleague: "purgesboleague",
    preaddmatchpending: "preaddmatchpending",
  },
  accessUrlPrefix: {
    status: "/monitor",
    asidebar: "/monitor",
    login: "/configuration",
    host: "/configuration",
    provider: "/configuration",
    function: "/system",
    page: "/system",
    role: "/system",
    user: "/system",
    setting: "/system",
    omcache: "/monitor",
    bot: "/configuration",
    proxy: "/configuration",
    league: "/list",
    mapleague: "/list",
    team: "/list",
    mapteam: "/list",
    sbomatch: "/match",
    ibcmatch: "/match",
    cmdmatch: "/match",
    linkedmatch: "/match",
    mapmatch: "/match",
    jobcontrol: "/configuration",
    oddslog: "/report",
    automap: "/match",
    sbologin: "/configuration",
    ibclogin: "/configuration",
    cmdlogin: "/configuration",
    sbobot: "/configuration",
    ibcbot: "/configuration",
    cmdbot: "/configuration",
    actionlog: "/log",
    unmapmatch: "/match",
    updatemapping: "/match",
    dangerzone: "/rb",
    matchfeed: "/rb",
    rtfcommentary: "/rb",
    mapoutright: "/match",
    remapmatch: "/match",
    remapleague: "/league",
    remapteam: "/team",
    preaddmatch: "/match",
    preaddmatchcmd: "/match",
    preaddmatchibet: "/match",
    jobcontrolsport: "/configuration",
    purgematch: "/match",
    sport: "/configuration",
    purgeleague: "/league",
    purgeteam: "/team",
    mapmatchothers: "/match",
    leaguelog: "/log",
    teamlog: "/log",
    mapleaguelog: "/log",
    mapteamlog: "/log",
    purgeleaguelog: "/log",
    purgeteamlog: "/log",
    purgesbomatchlog: "/log",
    purgeibcmatchlog: "/log",
    providerlog: "/log",
    matchlog: "/log",
    auditlog: "/log",
    mapmatchlog: "/log",
    preaddmatchlog: "/log",
    purgematchlog: "/log",
    hostlog: "/log",
    loginlog: "/log",
    proxylog: "/log",
    botlog: "/log",
    jobcontrollog: "/log",
    sportlog: "/log",
    matchclearrs: "/match",
    purgeibcteam: "/team",
    rsrtcontrol: "/match",
    rbdata: "/rb",
    efightapilog: "/log",
    cmdsbomatch: "/match",
    cmdsbomapmatch: "/match",
    ibcibtmatch: "/match",
    ibcibtmapmatch: "/match",
    outrightdoublematch: "/match",
    ip: "/system",
    purgeibcleague: "/league",
    preaddmatchpending: "/team",
  },
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      return "https://api." + domain;
    } else {
      return this.baseUrl;
    }
  },
  getRBBaseUrl() {
    return this.rbBaseUrl;
  },
  loginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userlogin";
  },
  functionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getfunctionlist";
  },
  addFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addfunction";
  },
  editFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editfunctioninfo";
  },
  deleteFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletefunction";
  },
  pageListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagelist";
  },
  addPageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addpage";
  },
  editPageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editpageinfo";
  },
  deletePageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletepage";
  },
  roleListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrolelist";
  },
  addRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addrole";
  },
  editRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editroleinfo";
  },
  deleteRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deleterole";
  },
  userListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getuserlist";
  },
  editUserStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userstatusupdate";
  },
  addUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/createuser";
  },
  editUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updateuser";
  },
  resetPwdUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userpasswordreset";
  },
  getUserRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getuserrole";
  },
  addUserRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/useraddroles";
  },
  pageFunctionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagefunctionlist";
  },
  pageRoleListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagerolelist";
  },
  editPageFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/upsertpagefunction";
  },
  editPageRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/upsertpagerole";
  },
  changePwdUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userchangepassword";
  },
  providerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getproviderlist";
  },
  addProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addprovider";
  },
  editProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editproviderinfo";
  },
  deleteProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deleteprovider";
  },
  editProviderDisabledUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerdisabled";
  },
  hostListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gethostlist";
  },
  addHostUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addhost";
  },
  editHostUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/edithostinfo";
  },
  deleteHostUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletehost";
  },
  editHostDisabledUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/hostdisabled";
  },
  loginListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getloginlist";
  },
  addLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addlogin";
  },
  editLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editlogininfo";
  },
  deleteLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletelogin";
  },
  editLoginDisabledUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/logindisabled";
  },
  updateLoginPasswordUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updateloginpassword";
  },
  statusListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getstatus";
  },
  getOMCacheUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getomcache";
  },
  getOMCacheKeyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getomcachekey";
  },
  botListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getbotlist";
  },
  addBotUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addbot";
  },
  editBotUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editbotinfo";
  },
  deleteBotUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletebot";
  },
  editBotDisabledUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/botdisabled";
  },
  updateBotTimeSyncUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatebottimesync";
  },
  getFreeLoginListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getfreeloginlist";
  },
  getBotLoginListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getbotloginlist";
  },
  updateBotLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatebotlogin";
  },
  proxyListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getproxylist";
  },
  addProxyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addproxy";
  },
  editProxyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editproxyinfo";
  },
  deleteProxyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deleteproxy";
  },
  editProxyDisabledUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/proxydisabled";
  },
  getFreeProxyListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getfreeproxylist";
  },
  getBotProxyListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getbotproxylist";
  },
  updateBotProxyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatebotproxy";
  },
  leagueListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getleaguelist";
  },
  leagueNationListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getleaguenationlist";
  },
  mapLeagueListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapleaguelist";
  },
  mapLeagueSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapleaguesboibc";
  },
  mapLeagueSBOCMDUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapleaguesbocmd";
  },
  unmapLeagueSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/unmapleaguesboibc";
  },
  unmapLeagueSBOCMDUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/unmapleaguesbocmd";
  },
  teamListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getteamlist";
  },
  teamNationListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getteamnationlist";
  },
  mapTeamListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapteamlist";
  },
  mapTeamSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapteamsboibc";
  },
  mapTeamSBOCMDUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapteamsbocmd";
  },
  unmapTeamSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/unmapteamsboibc";
  },
  unmapTeamSBOCMDUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/unmapteamsbocmd";
  },
  sportListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getsportlist";
  },
  ibcMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getibcmatchlist";
  },
  cmdMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getcmdmatchlist";
  },
  sboMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getsbomatchlist";
  },
  matchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchlist";
  },
  mapMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapmatchlist";
  },
  mapMatchManualSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapmatchmanualsboibc";
  },
  unmapMatchManualSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/unmapmatchmanualsboibc";
  },
  mapMatchManualSBOCMDUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapmatchmanualsbocmd";
  },
  unmapMatchManualSBOCMDUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/unmapmatchmanualsbocmd";
  },
  editMatchCMDEnabledUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchcmdenabled";
  },
  editMatchSemiAutoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchsemiauto";
  },
  editMatchLdiffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchldiff";
  },
  editMatchAutoOpenUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchautoopen";
  },
  updateMatchAffectValueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatematchaffectvalue";
  },
  addMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addmatch";
  },
  addLeagueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addleague";
  },
  addTeamUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addTeam";
  },
  swapMapMatchManualSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/swapmapmatchmanualsboibc";
  },
  swapMapMatchManualSBOCMDUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/swapmapmatchmanualsbocmd";
  },
  jobControlListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getjobcontrollist";
  },
  editJobControlUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editjobcontrolinfo";
  },
  oddsMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getoddsmatchlist";
  },
  oddsDataUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getoddsdata";
  },
  sboMatchOddsInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getsbomatchoddsinfo";
  },
  sboMatchOddsLogsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getsbomatchoddslogs";
  },
  ibcMatchOddsInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getibcmatchoddsinfo";
  },
  ibcMatchOddsLogsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getibcmatchoddslogs";
  },
  cmdMatchOddsInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getcmdmatchoddsinfo";
  },
  cmdMatchOddsLogsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getcmdmatchoddslogs";
  },
  autoMapUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/automap";
  },
  actionLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getactionlog";
  },
  matchLeagueListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchleaguelist";
  },
  unmapMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getunmapmatchlist";
  },
  duplicateMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getduplicatematchlist";
  },
  updateMatchMappingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatematchmapping";
  },
  updateMatchMappingListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getupdatematchmappinglist";
  },
  getDangerZoneUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getdangerzone";
  },
  getDangerZoneCornerUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getdangerzonecorner";
  },
  getDangerZoneBookingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getdangerzonebooking";
  },
  getDangerZoneGoalKickUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getdangerzonegoalkick";
  },
  getMatchFeedListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchfeedlist";
  },
  getMatchFeedsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchfeeds";
  },
  getMatchRepStatsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchrepstats";
  },
  getRtfCommUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrtfcommentary";
  },
  addDangerZoneUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adddangerzone";
  },
  addDangerZoneCornerUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adddangerzonecorner";
  },
  addDangerZoneBookingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adddangerzonebooking";
  },
  addDangerZoneGoalKickUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adddangerzonegoalkick";
  },
  lookupRtfCommUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/lookuprtfcommentary";
  },
  lookupRtfCommCornerUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/lookuprtfcommentarycorner";
  },
  lookupRtfCommBookingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/lookuprtfcommentarybooking";
  },
  lookupRtfCommGoalKickUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/lookuprtfcommentarygoalkick";
  },
  deleteDangerZoneUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletedangerzone";
  },
  deleteDangerZoneCornerUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletedangerzonecorner";
  },
  deleteDangerZoneBookingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletedangerzonebooking";
  },
  deleteDangerZoneGoalKickUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletedangerzonegoalkick";
  },
  deleteRtfCommUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletertfcommentary";
  },
  editRtfCommUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editrtfcommentaryinfo";
  },
  mapOutrightListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapoutrightlist";
  },
  matchOddsBetTypeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchoddsbettype";
  },
  matchOddsInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchoddsinfo";
  },
  matchOddsLogsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchoddslogs";
  },
  providerMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getprovidermatchlist";
  },
  remapMatchManualSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/remapmatchmanualsboibc";
  },
  providerLeagueListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getproviderleaguelist";
  },
  remapLeagueSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/remapleaguesboibc";
  },
  remapLeagueListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/remapleaguelist";
  },
  providerTeamListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getproviderteamlist";
  },
  remapTeamSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/remapteamsboibc";
  },
  remapTeamListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/remapteamlist";
  },
  leagueLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getleaguelookup";
  },
  teamLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getteamlookup";
  },
  createMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/creatematch";
  },
  leaguePairUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getleaguepair";
  },
  teamPairUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getteampair";
  },
  preAddMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/preaddmatch";
  },
  updateLeaguePreferUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updateleagueprefer";
  },
  updateTeamPreferUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updateteamprefer";
  },
  preAddMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpreaddmatchlist";
  },
  addSpecialMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addspecialmatch";
  },
  parentMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getparentmatchlist";
  },
  unmapSingleMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/unmapsinglematch";
  },
  remapSwapMatchManualSBOIBCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/remapswapmatchmanualsboibc";
  },
  jobControlSportListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getjobcontrolsportlist";
  },
  editJobControlSportUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editjobcontrolsportinfo";
  },
  getBotByLoginIdUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getbotbyloginid";
  },
  getParentLeagueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getparentleague";
  },
  purgeMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgematch";
  },
  getPurgeMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgematchlist";
  },
  updateSportAffectValueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatesportaffectvalue";
  },
  getParentMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getparentmatch";
  },
  matchInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchinfo";
  },
  purgeLeagueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgeleague";
  },
  purgeSBOLeagueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgesboleague";
  },
  getPurgeLeagueListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeleaguelist";
  },
  purgeTeamUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgeteam";
  },
  getPurgeTeamListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeteamlist";
  },
  getAddMatchByBatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getaddmatchbybatchlist";
  },
  addMatchByBatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addmatchbybatch";
  },
  purgeIBCMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgeibcmatch";
  },
  purgeSBOMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgesbomatch";
  },
  getLeagueLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getleaguelog";
  },
  getLeagueLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getleaguelogdetail";
  },
  getTeamLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getteamlog";
  },
  getTeamLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getteamlogdetail";
  },
  getMapLeagueLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmapleaguelog";
  },
  getMapLeagueLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmapleaguelogdetail";
  },
  getMapTeamLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmapteamlog";
  },
  getMapTeamLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmapteamlogdetail";
  },
  getPurgeLeagueLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeleaguelog";
  },
  getPurgeLeagueLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeleaguelogdetail";
  },
  getPurgeTeamLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeteamlog";
  },
  getPurgeTeamLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeteamlogdetail";
  },
  getPurgeSBOMatchLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgesbomatchlog";
  },
  getPurgeSBOMatchLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgesbomatchlogdetail";
  },
  getPurgeIBCMatchLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeibcmatchlog";
  },
  getPurgeIBCMatchLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeibcmatchlogdetail";
  },
  auditLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getauditlogdetail";
  },
  auditLogDetailRecordUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getauditlogdetailrecord";
  },
  getMatchLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchlog";
  },
  getMatchLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchlogdetail";
  },
  getMapMatchLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmapmatchlog";
  },
  getMapMatchLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmapmatchlogdetail";
  },
  getPreAddMatchLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpreaddmatchlog";
  },
  getPreAddMatchLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpreaddmatchlogdetail";
  },
  getPurgeMatchLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgematchlog";
  },
  getProviderLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getproviderlog";
  },
  getProviderLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getproviderlogdetail";
  },
  getHostLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gethostlog";
  },
  getHostLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gethostlogdetail";
  },
  getLoginLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getloginlog";
  },
  getLoginLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getloginlogdetail";
  },
  getProxyLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getproxylog";
  },
  getProxyLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getproxylogdetail";
  },
  getBotLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getbotlog";
  },
  getBotLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getbotlogdetail";
  },
  getJobControlLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getjobcontrollog";
  },
  getJobControlLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getjobcontrollogdetail";
  },
  getSportLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getsportlog";
  },
  getSportLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getsportlogdetail";
  },
  getPurgeMatchLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgematchlogdetail";
  },
  getPurgeLeagueLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeleaguelogdetail";
  },
  getPurgeTeamLogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpurgeteamlogdetail";
  },
  unlinkParentLeagueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/unlinkparentleague";
  },
  matchClearRsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchclearrs";
  },
  matchClearRsListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchclearrslist";
  },
  purgeIBCTeamUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgeibcteam";
  },
  purgeSBOTeamUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgesboteam";
  },
  matchClearRtUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchclearrt";
  },
  matchClearRSRTAllUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchclearrsrtall";
  },
  updateRSRTControlUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatersrtcontrol";
  },
  rsrtControlListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrsrtcontrollist";
  },
  getRBMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrbmatchlist";
  },
  getRBEventListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrbeventlist";
  },
  repullRBMatchListUrl() {
    return this.getRBBaseUrl() + this.rbMiddleUrl + "/repullrbdata";
  },
  getRBRawDataUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrbrawdata";
  },
  sendRBRawDataUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/sendrbrawdata";
  },
  getRBRawDataDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrbrawdatadetail";
  },
  getRBRepullDataDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrbrepulldatadetail";
  },
  sendRBEventFeedUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/sendrbeventfeed";
  },
  matchClearRcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchclearrc";
  },
  getEFightAPILogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getefightapilog";
  },
  getEFightAPILogDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getefightapilogdetail";
  },
  vipBotLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipbotlogin";
  },
  deleteLoginDisabledUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletelogindisabled";
  },
  cmdSBOMapMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmdsbomapmatchlist";
  },
  mapMatchCMDSBOUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapmatchcmdsbo";
  },
  cmdSBOMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getcmdsbomatchlist";
  },
  switchCMDSBOUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/switchcmdsbo";
  },
  purgeCMDSBOMapUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgecmdsbomap";
  },
  ibcIBTMapMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ibcibtmapmatchlist";
  },
  mapMatchIBCIBTUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mapmatchibcibt";
  },
  ibcIBTMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getibcibtmatchlist";
  },
  switchIBCIBTUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/switchibcibt";
  },
  purgeIBCIBTMapUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgeibcibtmap";
  },
  outrightDoubleMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getoutrightdoublematchlist";
  },
  ipListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getiplist";
  },
  addIpUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addip";
  },
  deleteIpUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deleteip";
  },
  purgeIBCLeagueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgeibcleague";
  },
  purgeSBOLeagueAutomapUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgesboleagueautomap";
  },
  purgeSBOTeamAutomapUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/purgesboteamautomap";
  },
  matchPreAddPendingListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getmatchpreaddpendinglist";
  },

  // OTP Binding URLs
  getOTP2faGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otp2fakeyget";
  },
  getOTP2faQrCodeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otp2faqr";
  },
  verifyOTP2faUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otp2favalidated";
  },
  validateOTP2faUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otpsessionupdate";
  },
  unbindOTP2faUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otp2fakeydisable";
  },
};
